import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";

const ProjectDetails = () => {
    const { slug } = useParams();
    const [project, setProject] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchProject = async () => {
            try {
                setIsLoading(true);
                const res = await fetch(`/api/projects/${slug}`);
                if (!res.ok) {
                    if (res.status === 404) throw new Error('Project not found');
                    throw new Error(`Failed to fetch project: ${res.status}`);
                }
                const data = await res.json();
                setProject(data);
            } catch (err) {
                setError(err.message || 'Unknown error');
            } finally {
                setIsLoading(false);
            }
        };
        fetchProject();
    }, [slug]);

    if (isLoading) {
        return <div className="text-white">Loading project…</div>;
    }

    if (error) {
        return (
            <div className="text-white">
                <p>Error: {error}</p>
                <p className="mt-12">
                    <Link className="text-blue-400" to="/projects">Back to Projects</Link>
                </p>
            </div>
        );
    }

    if (!project) {
        return (
            <div className="text-white">
                <p>Project not found.</p>
                <p className="mt-12">
                    <Link className="text-blue-400" to="/projects">Back to Projects</Link>
                </p>
            </div>
        );
    }

    const details = project.projectDetail || project.projectDetails || project.ProjectDetails || project.ProjectDetail;

    return (
        <div className="text-white px-24 py-24 mx-auto" style={{ maxWidth: 1000 }}>
            <p className="mb-12">
                <Link className="text-blue-400" to="/projects">← Back to Projects</Link>
            </p>
            {project.imageUrl ? (
                <img
                    src={project.imageUrl}
                    alt={project.title}
                    className="mx-auto"
                    style={{ width: '100%', maxHeight: 380, objectFit: 'contain' }}
                />
            ) : null}
            <h1 className="mt-16 text-center">{project.title}</h1>
            {project.tagline ? <h3 className="mt-8 text-center">{project.tagline}</h3> : null}
            {project.status ? <p className="mt-8 text-center">Status: {project.status}</p> : null}
            {project.description ? <p className="mt-12 text-center">{project.description}</p> : null}
            {details?.details ? <p className="mt-12 text-center">{details.details}</p> : null}
            {details?.content ? <div className="mt-12 whitespace-pre-wrap text-center">{details.content}</div> : null}
            {project.projectUrl ? (
                <p className="mt-16 text-center">
                    <a className="text-blue-400" href={project.projectUrl} target="_blank" rel="noreferrer">
                        Visit Project
                    </a>
                </p>
            ) : null}
        </div>
    );
}

export default ProjectDetails;

